
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export default function BookingNavbar() {
  const [scrolled, setScrolled] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleNavigation = (path: string) => {
    navigate(path);
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-white shadow-lg' : 'bg-white shadow-md'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 py-2">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <div className="flex items-center gap-3">
            <img 
              src="https://static.readdy.ai/image/8ba2fb49baf129fe47398873ffc1b622/ae217e5ef1f4a035b7b045b6b3280b3a.jpeg" 
              alt="Fluffy Pets Logo" 
              className="w-48 h-32 object-contain"
            />
          </div>

          <div className="hidden md:flex items-center gap-8">
            <button 
              onClick={() => handleNavigation('/')}
              className="text-[#6B4C9A] hover:text-[#FF9B9B] transition-colors cursor-pointer font-heading text-[28px] font-bold"
            >
              Home
            </button>
          </div>

          <button 
            onClick={() => handleNavigation('/')}
            className="bg-[#8B7BA8] text-white px-6 py-3 rounded-full hover:bg-[#6B4C9A] transition-all hover:scale-105 shadow-md whitespace-nowrap cursor-pointer font-medium"
          >
            Back to Home
          </button>
        </div>
      </div>
    </nav>
  );
}
